import React from 'react';
import styled from 'styled-components';
import Container from '../../../components/Container';
import MaczekSVG from './MaczekSVG';


const StyledWrapper = styled.div`
  width: 100%;
  padding: 60px 0 30px 0;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}) {
    padding: 30px 0 30px 0;
    background-color: ${({ theme }) => theme.colors.lightBlue};
  }
`;

const MaczekWrapper = styled.div`
  position: absolute;
  bottom: -29px;
  right: 0;
  z-index: 1;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}) {
    bottom: -75px;
  }
`;

interface BarWithMaczekProps {
  children: string,
}


const BarWithMaczek = ({ children }: BarWithMaczekProps) => (
  <StyledWrapper className="contactPageRectangle">
    <Container>
      <span>
        {children}
      </span>
      <MaczekWrapper>
        <MaczekSVG />
      </MaczekWrapper>
    </Container>
  </StyledWrapper>
);

export default BarWithMaczek;

